

const WINDOW_EVENTS = {
  CA_APP_LOGIN: "CA_APP_LOGIN",
  CA_APP_NAV_TO_LOGIN: "CA_APP_NAV_TO_LOGIN",
  CA_APP_NAV_TO_ONBOARDING: "CA_APP_NAV_TO_ONBOARDING",
  CA_APP_LOGOUT: "CA_APP_LOGOUT",
  CA_APP_PARENT: "CA_APP_PARENT",
  CD_OFFERINGS_TABLE: "CD-OFFERINGS-TABLE",
  CD_OFFERINGS_PURCHASE: "CD-OFFERINGS-PURCHASE",
  CD_OFFERINGS_LOGIN: "CD-OFFERINGS-LOGIN",
}

export { WINDOW_EVENTS };
